import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { RegistrationService } from '../../../../shared/services/auth/registration.service';
import { catchError, finalize } from 'rxjs/operators';
import { Regulation } from '../../../../shared/models/regulation.model';
import { StatementsComponent } from '../../statements/statements.component';
import { AnalyticsFormService } from '../../../../core/services/analytics-form.service';
import { throwError } from 'rxjs';
import { LoaderButtonType } from '../../../../shared/models/loader-button-type.enum';

@Component({
standalone: false,
  selector: 'app-step-email',
  templateUrl: './step-email.component.html',
  styleUrls: ['./step-email.component.scss'],


})
export class StepEmailComponent implements OnInit {

  @Input()
  statemates: Regulation[];

  @Input()
  formGroupName!: string;

  @ViewChild(StatementsComponent)
  statement: StatementsComponent;

  public submitted = false;
  public stepForm!: FormGroup;
  public formName = 'emailGroup';
  public loading = false;
  public errors: string[];

  constructor(private formGroupDirective: FormGroupDirective, private registrationService: RegistrationService,
              private analyticsFormService: AnalyticsFormService) {
  }

  ngOnInit(): void {
    this.stepForm = this.formGroupDirective.form.get(this.formGroupName) as FormGroup;
  }

  get email(): FormControl {
    return this.stepForm.get('email') as FormControl;
  }

  get acceptedRegulations(): FormControl {
    return this.stepForm.get('acceptedRegulations') as FormControl;
  }

  public onSubmit() {
    this.loading = true;
    if (this.stepForm.invalid) {
      this.submitted = true;
      this.stepForm.markAllAsTouched();

      if (this.stepForm.get('acceptedRegulations').invalid) {
        this.statement.toggle(true);
      }
      this.loading = false;
      return;
    }

    const registerData = this.stepForm.getRawValue();
    this.registrationService
      .registerEmail(registerData)
      .pipe(
        catchError((errors) => {
          this.submitted = true;
          this.errors = errors?.error?.errorCodes;
          this.analyticsFormService.sendEventForCaughtError('emailGroup', this.formName);
          return throwError(()=> errors);

        }),
        finalize(() => {
          this.loading = false;
        }),
      ).subscribe();
  }

  protected readonly LoaderButtonType = LoaderButtonType;
}
